import React from 'react';

const SectionHeader = ({ eyebrow, title, description, align = 'left', className = '' }) => {
  const alignClass =
    align === 'center' ? 'items-center text-center mx-auto' : 'items-start text-left';
  return (
    <div className={`mb-10 lg:mb-14 max-w-2xl ${alignClass} ${className}`}>
      {eyebrow ? (
        <div className={`flex items-center gap-3 mb-4 ${align === 'center' ? 'justify-center' : ''}`}>
          <span className="w-8 h-px bg-[#16A34A]" />
          <span className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#16A34A]">
            {eyebrow}
          </span>
        </div>
      ) : null}
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0a1628] tracking-tight leading-[1.08]">
        {title}
      </h2>
      {description ? (
        <p className="mt-5 text-slate-600 text-base md:text-lg leading-relaxed">{description}</p>
      ) : null}
    </div>
  );
};

export default SectionHeader;